// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2wAgy","show":"Modal_show__1p5OK"};